import { POLYGON_MAIN } from '@/lib/common/name-space';
import { axiosPost } from '../AxiosApi';
import axios, { AxiosResponse } from 'axios';

export type resEvmTxDataProps = {
  blockHash: string; // 블록 해쉬
  blockNumber: string; // 블록 번호
  confirmations: string; // 컴펌 수
  contractAddress: string; // 컨트랙트 주소
  cumulativeGasUsed: string; // 사용 가스량
  from: string; // 보낸 주소
  gas: string; // 가스량
  gasPrice: string; // 가스 가격
  gasUsed: string; // 가스 소비량
  hash: string; // 트랜잭션 해시
  input: string;
  isError: string; // ? 0이면 전송 성공일 듯
  nonce: string; // 논스
  timeStamp: string; // 시각
  to: string; // 받는 주소
  transactionIndex: string;
  txreceipt_status: string; // 1 성공
  value: string; // 수량
};
// {{polygon-scan-api}}?module=account&action=txlist&address=0x64673025Aac24e23d90F89F0F866b90bD521922A&startblock=0&endblock=99999999&page=1&offset=10&sort=desc&apikey={{polygon-scan-api-key}}

export const evmTxList = async (aAddress: `0x${string}` | string, aAction: string = 'txList') => {
  const payload = {
    apiUrl: process.env.REACT_APP_EVMSCAN,
    path: '',
    body: {
      module: 'account',
      action: aAction,
      address: aAddress,
      page: '1',
      offset: '100',
      sort: 'desc',
    },
    // path: `/api?module=account&action=txlist&address=${aAddress}&page=1&offset=20&sort=desc`
  };
  const re: AxiosResponse = await axiosPost(payload);
  return re;
};

export const evmTxHistoryList = async (aAddress: string) => {
  const config = {
    method: 'GET',
    maxBodyLength: Infinity,
    url: `${process.env.REACT_APP_POLYGON_API_URL}?chainid=${POLYGON_MAIN}&module=account&action=txlist&address=${aAddress}&startblock=0&endblock=99999999&page=1&offset=1000&sort=desc&apikey=${process.env.REACT_APP_POLYGON_API_KEY}`,
    headers: {},
  };
  const re = await axios(config);
  if (re.status !== 200) {
    return [];
  }
  return re.data.result;
};